module.exports = __webpack_public_path__ + "static/logo-gp20-homepage-alt-8a4babb59821d4ae9b75fab5e182dc83.png";